import React from "react";

const Heading = ({ data }) => {
//   console.log(data);
  return <h2 className="commonHeading">{data}</h2>;
};

export default Heading;
